import { ICommandBarItemProps, IconButton, Shimmer } from '@fluentui/react';
import React from 'react';
import { useGetProcurementOrdersQuery } from '../../../store/endpoints/ProcurementEndpoints';
import { PROCUREMENT_ORDER_STATUSES } from '../../../Constants';
import { IProcurementOrder } from '../../../models/Procurement';
import Widget from '../../Common/Widgets/Widget';

interface INeedsApprovalWidgetProps {
    onOrderClick: (orderId: string) => void;
    onFullscreenClick?: () => void;
    size?: 'small' | 'medium' | 'large';
    vendorFilter?: string;
}

const NeedsApprovalWidget: React.FC<INeedsApprovalWidgetProps> = (props) => {
    const orders = useGetProcurementOrdersQuery({ conditions: {
        filters: {
            'status': PROCUREMENT_ORDER_STATUSES.PENDING,
            ...(props.vendorFilter ? { vendor: props.vendorFilter } : {})
        }
    }})

    const refetch = () => {
        orders.refetch();
    }


    const farCommands: ICommandBarItemProps[] = [
        {
            key: 'refresh',
            iconOnly: true,
            iconProps: { iconName: 'Refresh' },
            onClick: refetch,
        },
        {
            key: 'fullscreen',
            iconOnly: true,
            iconProps: { iconName: 'OpenInNewWindow' },
            onClick: props.onFullscreenClick,
        }
    ]

    return (
        <Widget
        header='Orders Pending Approval'
        table={true}
        tableColspan={3}
        rightCommands={farCommands}
        size={props.size}
        tableHeaderRow={
            <tr>
                <th style={{width: '150px'}}>Vendor</th>
                <th>Items</th>
                <th style={{width: '1em'}}></th>
            </tr>
        }
        loading={orders.isFetching}
        shimmerRow={<tr>
            <td><Shimmer /></td>
            <td><Shimmer /></td>
            <td></td>
        </tr>}
        >
            {orders.data?.items.map(order => (
                <NeedsApprovalTableRow key={order.id} order={order} onClick={props.onOrderClick} />
            ))}
        </Widget>
    )
};

const NeedsApprovalTableRow: React.FC<{order: IProcurementOrder, onClick: (orderId: string) => void}> = (props) => {
    const click = () => {
        props.onClick(props.order.id ?? '');
    }

    return (
        <tr>
            <td>{props.order.vendor}</td>
            <td>{props.order.items.map(i => `${i.productName} (x${i.quantity})`).join(', ')}</td>
            <td>
                <IconButton iconProps={{ iconName: 'EntryView'}} onClick={click} />
            </td>
        </tr>
    );
}

export default NeedsApprovalWidget;